import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import StepperNavigationButtons from "../StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const ThemeCustomization = forwardRef(
  function ThemeCustomization(props, ref) {
    const [errors, setErrors] = useState({});

    const slide1ImageRef = useRef();
    const slide2ImageRef = useRef();
    const slide3ImageRef = useRef();

    const [slide1ImageKey, setSlide1ImageKey] = useState(null);
    const [slide2ImageKey, setSlide2ImageKey] = useState(null);
    const [slide3ImageKey, setSlide3ImageKey] = useState(null);

    useEffect(() => {
      resetData();
      if (props.data) {
        if (props.data.length > 0) {
          setSlide1ImageKey(props.data[0].imageKey);
          slide1ImageRef?.current?.setThumbnail(props.data[0].image);
          slide1ImageRef?.current?.setFileContent(props.data[0].imageFile);
        }

        if (props.data.length > 1) {
          setSlide2ImageKey(props.data[1].imageKey);
          slide2ImageRef?.current?.setThumbnail(props.data[1].image);
          slide2ImageRef?.current?.setFileContent(props.data[1].imageFile);
        }

        if (props.data.length > 2) {
          setSlide3ImageKey(props.data[2].imageKey);
          slide3ImageRef?.current?.setThumbnail(props.data[2].image);
          slide3ImageRef?.current?.setFileContent(props.data[2].imageFile);
        }
      }
    }, [props.data]);

    const resetData = () => {
      slide1ImageKey?.current?.setThumbnail(null);
      slide1ImageKey?.current?.setFileContent(null);
      slide2ImageKey?.current?.setThumbnail(null);
      slide2ImageKey?.current?.setFileContent(null);
      slide3ImageKey?.current?.setThumbnail(null);
      slide3ImageKey?.current?.setFileContent(null);
      setSlide1ImageKey(null);
      setSlide2ImageKey(null);
      setSlide3ImageKey(null);
    }

    const validate = () => {
      const errors = {};
      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

    const getData = () => {

      let sliders = [];

      if (slide1ImageRef?.current?.getThumbnail()) {
        sliders.push({
          image: slide1ImageRef?.current?.getThumbnail() ?? null,
          imageFile: slide1ImageRef?.current?.getImageFile() ?? null,
          imageKey: slide1ImageKey
        })
      }

      if (slide2ImageRef?.current?.getThumbnail()) {
        sliders.push({
          image: slide2ImageRef?.current?.getThumbnail() ?? null,
          imageFile: slide2ImageRef?.current?.getImageFile() ?? null,
          imageKey: slide2ImageKey
        })
      }

      if (slide3ImageRef?.current?.getThumbnail()) {
        sliders.push({
          image: slide3ImageRef?.current?.getThumbnail() ?? null,
          imageFile: slide3ImageRef?.current?.getImageFile() ?? null,
          imageKey: slide3ImageKey
        })
      }
      return sliders;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <>
        <div className="content d-block visible">
          <div className="content-header mb-3 d-flex justify-content-between flex-column flex-md-row">
            <div className="sec-titler">
              <h2 className="text-primary">Banners</h2>
              <div className="title-shape"></div>
              <small className="fs-11 mb-0">You can set upto 3 banners and each file size should not be more than 1MB</small>
              <br />
              <small className="fs-11 mb-0">Dimension : 1920px x 618px</small>
            </div>
          </div>
          <div className="row g-3">
            {errors.noSlider && (
              <div style={{ color: "#ea5455", fontSize: "0.8125rem" }}>
                {errors.noSlider}
              </div>
            )}

            <div className="col-sm-4">
              <label className="form-label" htmlFor="section1Image">
                Banner 1
              </label>

              <ImageBrowse elementId="slide1Image" ref={slide1ImageRef} imageType="slider"
                imageKey={slide1ImageKey} setImageKey={setSlide1ImageKey} imageDelete={props.imageDelete} />
            </div>

            <div className="col-sm-4">
              <label className="form-label" htmlFor="section1Image">
                Banner 2
              </label>
              <ImageBrowse elementId="slide2Image" ref={slide2ImageRef} imageType="slider"
                imageKey={slide2ImageKey} setImageKey={setSlide2ImageKey} imageDelete={props.imageDelete} />
            </div>

            <div className="col-sm-4">
              <label className="form-label" htmlFor="section1Image">
                Banner 3
              </label>
              <ImageBrowse elementId="slide3Image" ref={slide3ImageRef} imageType="slider"
                imageKey={slide3ImageKey} setImageKey={setSlide3ImageKey} imageDelete={props.imageDelete} />
            </div>

            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} save={props.save} />
          </div>
        </div>
      </>
    )
  });

export default ThemeCustomization;
